import React, {useMemo} from 'react'
import Teaser from '../../components/cms/teaser'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/cms/module-container'
import Heading from '../../components/cms/heading'
import teaserListSlotRecipe from './index.recipe'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import {parseAspectRatio} from '../../utils/utils'

const TeaserList = ({
    moduleId,
    moduleType,
    pageId,
    background,
    anchor,
    headingLevel,
    heading,
    teaserList,
    imageRatio,
    teaserBackground,
    spacing
}) => {
    const recipe = useSlotRecipe({recipe: teaserListSlotRecipe})

    const isOneTeaser = teaserList.length === 1
    const styles = useMemo(() => recipe({isOneTeaser}), [recipe, isOneTeaser])

    return (
        <ModuleContainer
            moduleId={moduleId}
            moduleType={moduleType}
            pageId={pageId}
            anchor={anchor}
            background={background}
            spacing={spacing}
            css={styles.root}
            heading={heading}
        >
            <Box css={styles.heading}>
                <Heading {...heading} alignment="inherit" headingLevel={headingLevel} />
            </Box>

            <Box css={styles.teasersContainer}>
                {teaserList.map((teaser, index) => (
                    <Teaser
                        key={index}
                        {...teaser}
                        aspectRatio={parseAspectRatio(imageRatio)}
                        teaserBackground={teaserBackground}
                        widths={{
                            base: '88vw',
                            s: `${Math.ceil(87.5 / Math.max(2, teaserList.length))}vw`,
                            l: Math.ceil(1680 / Math.max(2, teaserList.length))
                        }}
                    ></Teaser>
                ))}
            </Box>
        </ModuleContainer>
    )
}

TeaserList.propTypes = {
    anchor: PropTypes.string,
    background: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    teaserList: PropTypes.array,
    imageRatio: PropTypes.string,
    teaserBackground: PropTypes.bool,
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default TeaserList
